import { render, staticRenderFns } from "./QuestionnaireFormatObjectDrawer.vue?vue&type=template&id=4b207301&scoped=true&"
import script from "./QuestionnaireFormatObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatObjectDrawer.vue?vue&type=style&index=0&id=4b207301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b207301",
  null
  
)

export default component.exports